import React from 'react'

function Salary() {
  return (
    <div>Salary</div>
  )
}

export default Salary